import { MAIN_PHONE_NUMBER } from '@constants/index'
import { usePageSettings } from '@providers/page-settings'
import { useNodeParams } from 'admin/hooks/useNodeParams'
import { AvailableComponentTypes, AvailablePageNodes } from 'admin/types'

const SITE_URL = 'https://credit.club'
const LOGO_URL = `${SITE_URL}/logo.png`
const PRICE_DESCRIPTION =
	'Чтобы узнать ставку по кредиту, оставьте заявку и предоставьте согласия на запрос кредитной истории через портал Госуслуг'

const toISO8601 = (dateStr: string | undefined): string | undefined => {
	if (!dateStr) return undefined
	const date = new Date(dateStr)
	return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
}

export const SEO = () => {
	const { admin: { page } = {} } = usePageSettings()
	const { name, pageNode, url: pageUrl, dateCreated } = page ?? {}
	const mainBlock = pageNode?.find(({ name: n }) => n === AvailablePageNodes.main_block)
	const mainBlockData = useNodeParams(mainBlock?.nodeParam ?? [])
	const [image, description, stringArray = '']: string[] = [
		mainBlockData.get(AvailableComponentTypes.url),
		mainBlockData.get(AvailableComponentTypes.description),
		mainBlockData.get(AvailableComponentTypes.stringArray),
	]
	const serviceUrl = pageUrl ? `${SITE_URL}${pageUrl.startsWith('/') ? '' : '/'}${pageUrl}` : undefined
	const datePublished = toISO8601(dateCreated)
	const dateModified = datePublished
	const offerLines = stringArray ? stringArray.split('\n').filter(Boolean) : []

	if (!mainBlock) return null

	return (
		<div hidden itemScope itemType='https://schema.org/Service'>
			{serviceUrl && <link itemProp='url' href={serviceUrl} />}
			<h1 itemProp='serviceType'>{name}</h1>
			<div itemProp='provider' itemScope itemType='https://schema.org/Organization'>
				<span itemProp='name'>Credit.Club</span>
				<link itemProp='url' href={SITE_URL} />
				<link itemProp='logo' href={LOGO_URL} />
			</div>
			{datePublished && <meta itemProp='datePublished' content={datePublished} />}
			{dateModified && <meta itemProp='dateModified' content={dateModified} />}
			{image && <link itemProp='image' href={image} />}
			<div itemProp='description'>
				{description}
				{!!offerLines.length && (
					<>
						{' '}
						{offerLines.map((item, index) => (
							<span key={index}>{item}</span>
						))}
					</>
				)}
			</div>
			<div itemProp='offers' itemScope itemType='https://schema.org/Offer'>
				<meta itemProp='priceCurrency' content='RUB' />
				<span itemProp='price'>{PRICE_DESCRIPTION}</span>
			</div>
			<div itemProp='contactPoint' itemScope itemType='https://schema.org/ContactPoint'>
				<span itemProp='name'>Сайт: Credit.Club</span>
				<span itemProp='telephone'>{MAIN_PHONE_NUMBER}</span>
				<link itemProp='url' href={SITE_URL} />
			</div>
		</div>
	)
}
